<div fxLayout="column">
    <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="bold">
        <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
            <span fxFlex="33">Vendor Name</span>
            <span fxFlex="33">Payable Number</span>
            <span fxFlex="33">Description</span>
        </div>
        <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="numeric">
            <span fxFlex="25">Invoice Date</span>
            <span fxFlex="25">Post Date</span>
            <span fxFlex="25">Payable Due Date</span>
            <span fxFlex="25">Payable Amount</span>
        </div>
    </div>

    <mat-divider class="mt10"></mat-divider>

    <div *ngFor="let item of vendors" fxLayout="column">

        <div *ngFor="let invoice of item.value; first as isFirstInvoice; last as isLastInvoice" class="mt10" fxFlex="auto" fxLayout="column">

            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">

                <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
                    <span *ngIf="isFirstInvoice" fxFlex="33">{{invoice.VendorName}}</span>
                    <span *ngIf="!isFirstInvoice" fxFlex="33"></span>
                    <span fxFlex="33">{{invoice.Number}}</span>
                    <span fxFlex="33">{{invoice.Description}}</span>
                </div>

                <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                    <span fxFlex="25">{{invoice.PayableDate | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{invoice.PostDate | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{invoice.DueDate | date:'M/d/yyyy'}}</span>
                    <span fxFlex="25">{{invoice.TotalAmount | currency}}</span>
                </div>
            </div>

            <div class="mt20" fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
                <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
                    <span *ngIf="isFirstInvoice" fxFlex="33"><strong>Bank:</strong> {{invoice.BankCode}}</span>
                    <span *ngIf="!isFirstInvoice" fxFlex="33"></span>
                    <span fxFlex="33"><strong>Units</strong></span>
                    <span fxFlex="33"><strong>Item Description</strong></span>
                </div>

                <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="numeric bold">
                    <span fxFlex="20">Account</span>
                    <span fxFlex="25">Project Account</span>
                    <span fxFlex="15">Tax</span>
                    <span fxFlex="20">Shipping</span>
                    <span fxFlex="20">Total</span>
                </div>
            </div>

            <div *ngFor="let item of invoice.PayableItems; last as isLastItem" fxFlex="auto" fxLayout="column">
                <div class="mt10" fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">

                    <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
                        <span fxFlex="33"></span>
                        <span fxFlex="33">{{item.Units}}</span>
                        <span fxFlex="33">{{item.Description}}</span>
                    </div>

                    <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                        <span fxFlex="20">{{item.DistributionAccount}}</span>
                        <span fxFlex="25">{{item.ProjectAccountNumber}}</span>
                        <span fxFlex="15">{{item.TaxAmount | currency}}</span>
                        <span fxFlex="20">{{item.ShippingAmount | currency}}</span>
                        <span fxFlex="20">{{item.Amount | currency}}</span>
                    </div>
                </div>

                <mat-divider *ngIf="isLastItem && !isLastInvoice" class="mt10 space-left"></mat-divider>
            </div>
        </div>
        <mat-divider class="mt10"></mat-divider>
    </div>

    <div fxFlex="auto" fxLayout="column">
        <h3>Payable Summary</h3>
        <div fxLayout="column" class="center">
            <div fxFlex="50" fxLayout="row">
                <span fxFlex="30"><strong>Type</strong></span>
                <span fxFlex="20" class="numeric"><strong>Count</strong></span>
                <span fxFlex="50" class="numeric"><strong>Total Amount</strong></span>
            </div>

            <div *ngFor="let item of totals" fxLayout="row" fxLayoutAlign="space-between start">
                <span fxFlex="30">{{item.key}}</span>
                <span fxFlex="20" class="numeric">{{item.value.count}}</span>
                <span fxFlex="50" class="numeric">{{item.value.amount | currency}}</span>
            </div>

            <mat-divider class="space-above"></mat-divider>
        </div>
        <div class="center space-above">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span fxFlex="30"><strong>Totals:</strong></span>
                <span fxFlex="20" class="numeric">{{count}}</span>
                <span fxFlex="50" class="numeric">{{grandTotal | currency}}</span>
            </div>
        </div>
    </div>
</div>